enum ProductionReason {
  Good = "GoodProduction",
  Bad = "BadProduction",
}
export default ProductionReason;
